import { Routes } from '@angular/router'
import { AppLayoutComponent } from './core/feature/app-layout/app-layout.component'
import { authGuard } from './core/guards/auth.guard'
import { NotFoundComponent } from './core/feature/not-found/not-found.component'
import { UserNotAuthenticatedComponent } from './core/feature/user-not-authenticated/user-not-authenticated.component'
import { NoChantierComponent } from './core/feature/no-chantier/no-chantier.component'
import { globalResolver } from './shared/resolvers/global.resolver'
import { droitsrhGuard } from './core/guards/droitsrh.guard'
import { superAdminGuard } from './core/guards/super-admin.guard'

export const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [authGuard],
        resolve: { params: globalResolver },
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadChildren: () => import('./home/feature/home.routes').then((m) => m.HOME_ROUTES),
            },
            {
                path: 'chantiers/:chantierCode',
                loadChildren: () => import('./home/feature/home.routes').then((m) => m.HOME_ROUTES),
            },
            {
                path: 'admin',
                canActivate: [superAdminGuard()],
                loadChildren: () => import('./admin/feature/admin.routes').then((m) => m.ADMIN_ROUTES),
            },
            {
                path: 'admin-import-beton',
                canActivate: [superAdminGuard()],
                loadChildren: () =>
                    import('./admin-import-beton/feature/admin-import-beton.routes').then(
                        (m) => m.ADMIN_IMPORT_BETON_ROUTES,
                    ),
            },
            {
                path: 'droitsrh',
                canActivate: [droitsrhGuard()],
                loadChildren: () => import('./droitsrh/feature/droitsrh.routes').then((m) => m.DROITSRH_ROUTES),
            },
            {
                path: 'accueil-chantier',
                loadChildren: () =>
                    import('./accueil-chantier/feature/accueil-chantier.routes').then((m) => m.ACCUEIL_CHANTIER_ROUTES),
            },
            {
                path: 'interim',
                loadChildren: () => import('./interim/feature/interim.routes').then((m) => m.INTERIM_ROUTES),
            },
            {
                path: 'documentation',
                loadChildren: () =>
                    import('./documentation/feature/documentation.routes').then((m) => m.DOCUMENTATION_ROUTES),
            },
            {
                path: 'donnees-interimaires',
                loadChildren: () =>
                    import('./donnees-interimaires/feature/donnees-interimaires.routes').then(
                        (m) => m.DONNEES_INTERIMAIRES_ROUTES,
                    ),
            },
            { path: 'not-found', component: NotFoundComponent },
            { path: 'no-chantier', component: NoChantierComponent },
        ],
    },
    { path: 'user-not-authenticated', component: UserNotAuthenticatedComponent },
    { path: '**', redirectTo: 'not-found' },
]
